__turbopack_context__.v({
  "kbd": "kbd-module__gG9wpa__kbd",
  "small": "kbd-module__gG9wpa__small",
});
